import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-users',
  templateUrl: './portal-users.component.html',
  styleUrls: ['./portal-users.component.css']
})
export class PortalUsersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
